import { Camera, Status } from '@EcamModel/model';
import { BaseModel } from '@Core';
import { CameraPhotoVehicles } from './CameraPhotoVehicles';
import { ContraventionReasons } from './ContraventionReasons';
import { GeoZoneCoordinates } from './GeoZoneCoordinates';
import { GeoZoneOperationConfigWithGracePeriod } from './GeoZoneOperationConfig';
import { GeoZoneOperations } from './GeoZoneOperations';
import { CameraView } from './CameraView';
import { GeoZoneGroups } from './GeoZoneGroups';
import { Zones } from './Zones';

export interface GeoZones extends BaseModel {
    CameraId: number;
    Camera?: Camera;

    ContraventionReasonId?: number;
    ContraventionReason?: ContraventionReasons;

    GeoZoneCoordinates?: GeoZoneCoordinates[];

    GeoZoneOperations?: GeoZoneOperations[];

    CameraPhotoVehicles?: CameraPhotoVehicles[];

    GracePeriod?: number;

    Status?: Status;

    CameraViewId?: number;
    CameraView?: CameraView;
    CameraViewZoomId?: number;
    CameraViewDetail?: CameraView;
    GeoZoneType?: GeoZoneType;

    ValidationType?: GeoZoneValidationType;

    PermitExemptionsEnabled?: boolean;

    GZOConfigs?: GeoZoneOperationConfigWithGracePeriod[];

    GeoZoneName?: string;

    GeoZoneDetailCount?: number;
    ContraventionType?: string;

    VehicleCount?: number;
    TotalBay?: number;

    PostCaptureInterval?: number;
    PostCaptureNumber?: number;

    GeoZoneGroupId?: number;
    GeoZoneGroup?: GeoZoneGroups;

    ZoneId?: number;
    Zone?: Zones;
}

export enum GeoZoneValidationType {
    Covered,
    Center,
    Contained,
}

export enum GeoZoneType {
    Detail,
    Overview,
}

export interface GeoZoneByZoneResult extends BaseModel {
    GeoZoneId: number;
    GeoZoneName: string;
    GeoZoneGroupName: string;
    CameraName: string;
    ContraventionReason: string;
    MonitoredByCameras: string;
    Status: Status;
}
